<template>
  <section class="tags-article">
    <section class="article-content" v-if="article.length > 0">
      <!--普通文章-->
      <ul v-if="currentTag !== '会员专享'" class="article-ul">
        <li v-for=" item in article" :key="item.postId" class="article-li">
          <a
            class="detail-left"
            :class="currentTag === '机构' ? 'organizationLeft' : '' "
            :href="$i18n.path(`p/${item.postId}`)"
            target="_blank"
          >
            <img
              class="article-img"
              :src="item.picturePath.replace('?x-oss-process=style/wm','') + '?x-oss-process=image/resize,m_fixed,w_360,h_250/quality,Q_60'"
              :alt="item.articleTitle"
            />
          </a>
          <section class="detail-right" :class="currentTag === '机构' ? 'organizationRight' : '' ">
            <a :href="$i18n.path(`p/${item.postId}`)" target="_blank">
              <h2>{{ item.articleTitle }}</h2>
              <summary>{{ item.articleSummary }}</summary>
            </a>

            <section class="author-title" v-if="currentTag !== '机构'">
              <a
                :href="$i18n.path(`user/${item.userId}?type=article`)"
                class="author"
                target="_blank"
              >
                <img :src="item.authorAvatar" alt />
                <span>{{ item.author }}</span>
              </a>
              <p class="title">
                <span class="iconfont">&#xe605;</span>
                {{ item.publishTime | formatTime}}
              </p>
            </section>

            <section class="time-stock" v-else>
              <p class="time">
                <span class="iconfont">&#xe605;</span>
                <span>{{ item.publishTime | formatTime}}</span>
              </p>
              <p class="stock" v-if="item.stocks">
                <a
                  target="_blank"
                  v-for="item in item.stocks"
                  :key="item.stockCode"
                  :href="$i18n.path(`stock/${item.stockCode}`)"
                >
                  <span>{{item.stockName}} {{item.stockCode}}</span>
                </a>
              </p>
            </section>
          </section>
        </li>
      </ul>
      <!--付费和非付费-->
      <ul v-else class="article-ul">
        <li v-for="(item,index) in article" :key="item.contents.timestamp+index" class="article-li">
          <a class="detail-left" :href="$i18n.path(`p/${item.contents.contentId}?true`)">
            <img
              class="article-img"
              :src="item.contents.coverImages[0].replace('?x-oss-process=style/wm','') + '?x-oss-process=image/resize,m_fixed,w_360,h_250/quality,Q_60'"
              :alt="item.contents.title"
            />
          </a>
          <section class="detail-right">
            <a :href="$i18n.path(`p/${item.contents.contentId}`)" target="_blank">
              <h2>{{ item.contents.title }}</h2>
              <summary>{{ item.contents.summary }}</summary>
            </a>
            <section class="time-button">
              <span>{{ item.contents.timestamp | formatTime }}</span>
            </section>
          </section>
        </li>
      </ul>
    </section>
  </section>
</template>
<script>
export default {
  props: ['article'],
  data() {
    return {
      currentTag: ''
    };
  },
  components: {},
  methods: {
    preventDefault(e) {
      // 阻止默认事件
      let event = e || window.event;
      event.preventDefault();
    },
    changeTag(i, e) {
      this.preventDefault(e);
      this.currentTag = i;
      this.$emit('getTagArticle', i);
    },
    getMore() {
      if (this.currentTag !== '会员专享') {
        this.$emit('getMoreArticle', this.currentTag);
      } else {
        this.$emit('getMoreResearchReport');
      }
    }
  },
  created() {
    this.currentTag = this.$route.params.type;
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.params);
        this.currentTag = this.$route.params.type;
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.tags-article {
  width: 852px;
  background: #fff;
  // padding: 0 20px 20px;
  padding-bottom: 20px;
  // margin-top: 20px;

  .article-content {
    width: 100%;
    padding: 0 20px;
    .article-ul {
      width: 100%;
      padding-top: 20px;

      .article-li {
        height: 145px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 0.5px solid #f4f5f9;
        &:last-child {
          border-bottom: none;
        }
        .detail-left {
          width: 180px;
          height: 125px;
          cursor: pointer;
          display: block;
          overflow: hidden;
          border-radius: 5px;

          .article-img {
            // width: 100%;
            height: 100%;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.4s ease;
          }

          &:hover .article-img {
            // width: 105%;
            height: 105%;
          }

          &.organizationLeft {
            width: 127px;
            height: 127px;
            border: 1px solid #f3f3f3;
          }
        }

        .detail-right {
          width: 609px;
          position: relative;

          &.organizationRight {
            width: 632px;
            height: 144px;
          }

          a {
            h2 {
              margin-bottom: 10px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              line-height: 1.4;
              font-weight: 600;
              font-size: 18px;
              color: #333;
              cursor: pointer;
              max-height: 50px;
              &:hover {
                color: #3278d2;
              }
            }

            summary {
              height: 40px;
              font-size: 14px;
              line-height: 20px;
              overflow: hidden;
              color: #666;
              cursor: pointer;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;

              &:hover {
                color: #000;
              }
            }
          }

          .author-title {
            width: 100%;
            height: 26px;
            font-size: 12px;
            line-height: 26px;
            left: 0;
            bottom: 0;
            position: absolute;

            .author {
              display: flex;
              justify-content: space-around;
              align-items: center;
              float: left;
              cursor: pointer;
              color: #000;
              img {
                border-radius: 50%;
                width: 26px;
                height: 26px;
                margin-right: 5px;
                border: 1px solid #ccc;
              }
              &:hover {
                color: #3178d2;
              }
            }

            .title {
              font-size: 12px;
              font-weight: 400;
              color: #949ca5;
              height: 26px;
              line-height: 26px;
              float: right;
              .iconfont {
                font-size: 12px;
              }
            }
          }

          .time-stock {
            width: 100%;
            height: 26px;
            font-size: 12px;
            line-height: 26px;
            left: 0;
            bottom: 20px;
            position: absolute;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .time {
              .iconfont {
                font-size: 12px;
              }
            }
            .stock {
              background: #edf3fa;
              font-size: 12px;
              font-weight: 400;
              padding: 0 14px;
              margin-left: 10px;
              height: 30px;
              line-height: 30px;

              a {
                color: #3278d2;
              }
            }
          }

          .time-button {
            width: 100%;
            height: 26px;
            font-size: 12px;
            line-height: 26px;
            left: 0;
            bottom: 0;
            position: absolute;
            display: flex;
            justify-content: space-between;
            align-items: center;

            button {
              width: 90px;
              height: 28px;
              border: none;
              outline: none;
              background: #f93;
              border-radius: 2px;
              font-size: 14px;
              // font-family: MicrosoftYaHei-Bold;
              font-weight: 700;
              color: #fff;
              line-height: 28px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }

    // #waterfall {
    //   color: #fff;
    //   text-align: center;
    //   padding: 20px 0;
    //   background-color: #fff;
    //   border-radius: 4px;

    //   span {
    //     background-color: #3178d2;
    //     border-radius: 5px;
    //     cursor: pointer;
    //     transition: all 0.3s ease;
    //     font-size: 14px;
    //     padding: 8px 52px;
    //   }
    // }

    #waterfall-nomore {
      display: flex;
      align-items: center;
      justify-content: center;
      .line {
        width: 100px;
        height: 2px;
        margin: 0 10px;
        background-color: #e8e8e8;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        text-align: center;
      }
    }
  }
}
</style>
